import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import en from '../locales/en.json'
import uk from '../locales/uk.json'
import de from '../locales/de.json'
import cs from '../locales/cs.json'
import { PRODUCT_NAME } from './branding'

export const SUPPORTED_LANGUAGES = ['en', 'uk', 'de', 'cs'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
}

// Initialise once at module load. `LanguageDetector` looks at (in order):
// localStorage key `i18nextLng`, then navigator.language(s), then HTML lang.
// We persist under the same key whenever the operator changes the language
// from the picker, and on login we override with the authenticated user's
// stored preference (see AuthProvider).
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      uk: { translation: uk },
      de: { translation: de },
      cs: { translation: cs },
    },
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    fallbackLng: 'en',
    // `en-US` etc. → `en`.
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
      defaultVariables: { product: PRODUCT_NAME },
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    returnNull: false,
    react: {
      // Resources are bundled, so init finishes synchronously — skipping
      // Suspense avoids forcing callers to wrap themselves.
      useSuspense: false,
    },
  })

export { i18n }
